export enum WorkOrderLineColumns {
    work_order_line_id = 'work_order_line_id',
    work_order_id = 'work_order_id',
    product_id = 'product_id',
    creation_date = 'creation_date',
    quantity = 'quantity',
    unit_price = 'unit_price',
    final_price_to_pay = 'final_price_to_pay',
    data = 'data',
}

export interface WorkOrderLineAttributes {
    work_order_line_id: number;
    work_order_id: number | null;
    product_id: number | null;
    creation_date: Date | null;
    quantity: number | null;
    unit_price: number | null;
    final_price_to_pay: number | null;
    data: any | null;
}

export type WorkOrderLineOptionalAttributes =
    | 'work_order_line_id'
    | 'work_order_id'
    | 'product_id'
    | 'creation_date'
    | 'quantity'
    | 'unit_price'
    | 'final_price_to_pay'
    | 'data';
export interface WorkOrderLineCreate {
    work_order_line_id?: number;
    work_order_id?: number | null;
    product_id?: number | null;
    creation_date?: Date | null;
    quantity?: number | null;
    unit_price?: number | null;
    final_price_to_pay?: number | null;
    data?: any | null;
}
